import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18 11a7 7 0 1 0-14 0 7 7 0 0 0 14 0zm2 0a8.96 8.96 0 0 1-1.969 5.617l3.676 3.676a1 1 0 1 1-1.414 1.414l-3.676-3.676A9 9 0 1 1 20 11z",
		fill: "currentColor"
	})
});
export default SvgSearch;
